import axiosInstance from "@/axios/axiosInstance";
import {
  AccountDeletionRequest,
  AccountDeletionResponse,
  AccountDeletionApiResponse,
} from "@/interface/settings/account-deletion.interface";

const parseApiErrorMessage = (error: any): string => {
  const errorMessage = error?.response?.data?.errors?.[0]?.message;
  if (errorMessage) return errorMessage;

  const fallbackMessage = "Failed to deactivate account";
  const anyError = error as unknown as { response?: { data?: unknown } };
  const data = anyError?.response?.data ?? anyError;

  if (!data) return fallbackMessage;
  if (typeof data === "string") return data || fallbackMessage;

  // Common API shape: { message: string, errors: Array<{ message | field }> }
  try {
    const anyData = data as {
      message?: string;
      errors?: Array<{ message?: string; field?: string }>;
    };
    const message = anyData?.message as string | undefined;
    const errors = Array.isArray(anyData?.errors) ? anyData.errors : [];
    const firstError = (errors?.[0] ?? {}) as {
      message?: string;
      field?: string;
    };
    const firstErrorMessage =
      // prefer explicit message
      (firstError?.message as string | undefined) ||
      // sometimes APIs put message in field when not tied to a real field
      (firstError?.field as string | undefined);

    return firstErrorMessage || message || fallbackMessage;
  } catch (_e) {
    return fallbackMessage;
  }
};

export const accountDeletionService = {
  /**
   * Request account deactivation
   * @param data - Account deletion request with reason
   * @returns Promise<AccountDeletionResponse>
   */
  deactivateAccount: async (
    data: AccountDeletionRequest
  ): Promise<AccountDeletionResponse> => {
    try {
      const response = await axiosInstance.post<AccountDeletionApiResponse>(
        "/Profile/DeactivateAccount",
        data
      );
      return response.data.data;
    } catch (error) {
      const errorMessage = parseApiErrorMessage(error);
      throw new Error(errorMessage);
    }
  },
};

